import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function PainManagement() {
  useEffect(() => {
    document.title = "Pain Management Procedures | Viksha Health Care";
    const newMetaDescription =
      "Pain management procedures at Viksha Health Care for joint and musculoskeletal pain. Learn options to reduce pain and improve daily function.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Pain Management Procedures</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/painManagement.jpg" />
        </div>
        <div className="textareaofser">
          <h1>Pain Management Procedures</h1>

          <p>
            Pain management procedures are used to relieve persistent
            musculoskeletal pain when medications, rest, and physiotherapy alone
            do not provide sufficient relief. These treatments focus on reducing
            pain, improving mobility, and helping patients return to daily
            activities comfortably.
          </p>

          <p>
            Procedures are selected based on the underlying condition, severity
            of pain, and individual patient needs. The goal is to manage pain
            effectively while supporting long-term joint and muscle health.
          </p>

          <h5>Common Conditions Treated</h5>
          <ul>
            <li>Chronic joint pain (knee, shoulder, hip, ankle)</li>
            <li>Back and neck pain</li>
            <li>Inflammatory joint conditions</li>
            <li>Tendon and soft tissue pain</li>
            <li>Post-injury or post-surgical pain</li>
          </ul>

          <h5>Types of Pain Management Procedures</h5>

          <h6>Joint Injections</h6>
          <p>
            Injections may be used to deliver medication directly into a painful
            joint to reduce inflammation and provide relief. These procedures
            are usually combined with physiotherapy and lifestyle changes.
          </p>

          <h6>Soft Tissue Injections</h6>
          <p>
            Targeted injections around tendons or muscles may help relieve pain
            caused by inflammation or overuse injuries.
          </p>

          <h6>Regenerative Therapies (When Appropriate)</h6>
          <p>
            Some patients may benefit from advanced non-surgical options aimed
            at supporting the body’s natural healing processes in selected
            conditions.
          </p>

          <h5>Benefits of Pain Management Procedures</h5>
          <ul>
            <li>Reduction in pain and inflammation</li>
            <li>Improved joint movement and function</li>
            <li>Enhanced ability to participate in rehabilitation</li>
            <li>Better quality of life and daily comfort</li>
          </ul>

          <h5>How These Procedures Support Recovery</h5>
          <p>
            Pain relief allows patients to participate more actively in
            physiotherapy and strengthening exercises. This helps address the
            root cause of pain and improves long-term outcomes rather than only
            providing temporary relief.
          </p>

          <h5>Safety and Monitoring</h5>
          <p>
            These procedures are performed with careful technique and
            appropriate precautions. Patients are monitored during and after the
            procedure, and follow-up visits help assess response and guide
            further care if needed.
          </p>

          <h5>What to Expect After the Procedure</h5>
          <p>
            Most procedures are done on an outpatient basis. Mild soreness may
            occur temporarily, and patients are advised on activity modification
            and follow-up care to ensure the best results.
          </p>

          <h5>Importance of Comprehensive Care</h5>
          <p>
            Pain management procedures are most effective when combined with
            exercises, posture correction, weight management, and other
            lifestyle measures that address the root cause of pain.
          </p>

          <h5>When to Consider Pain Management Procedures</h5>
          <ul>
            <li>Pain lasting several weeks despite treatment</li>
            <li>Difficulty performing daily activities due to pain</li>
            <li>Limited improvement with medications and physiotherapy</li>
            <li>Recurring joint or soft tissue inflammation</li>
          </ul>

          <p>
            Properly guided pain management procedures can provide relief,
            support recovery, and help individuals regain confidence in movement
            and daily activities.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(PainManagement);
